import { createAction, props } from '@ngrx/store';
import { Country } from '@sharedModule/models/country.model';

export const loadCountry = createAction('[Country] Load Country');

export const loadCountrySuccess = createAction(
  '[Country] Load Country Success',
  props<{ countries: Country[] }>()
);

export const loadCountryFailure = createAction(
  '[Country] Load Country Failure',
  props<{ error: string }>()
);
